<template>
  <div class="item-selector">
    <div class="">
      <div v-if="item.item_id" class="selected-item">
        {{ item.part_number }}
        <!-- <span class="deselect-icon" @click="deselectItem">
          <font-awesome-icon icon="times-circle" />
        </span> -->
      </div>
      <base-select
        v-else
        v-model="itemSelect"
        :options="itemOptions"
        :show-labels="false"
        :preserve-search="true"
        :initial-search="item.part_number"
        :invalid="invalid"
        :placeholder="$t('invoices.item.select_an_item')"
        label="part_number"
        class="multi-select-item"
        @select="(val) => $emit('select', val)"
      >
      </base-select>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false
    },
    invalidDescription: {
      type: Boolean,
      required: false,
      default: false
    },
    taxPerItem: {
      type: String,
      default: ''
    },
    taxes: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      itemSelect: null,
      loading: false,
      type:'',
      itemOptions:[]
    }
  },
  computed: {
    ...mapGetters('item', [
      'items'
    ]),
    ...mapGetters('invoice', [
      'availableInvoiceItems'
    ]),
  },
  watch: {
    invalidDescription (newValue) {
    },
  },
  created(){
    this.InvoiceType();
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('item', [
      'fetchItems'
    ]),
    InvoiceType(){

      this.itemOptions = this.availableInvoiceItems

    },
    async searchItems (search) {
      let data = {
        filter: {
          name: search,
          unit: '',
          price: '',
          part_number:'',
        },
        orderByField: '',
        orderBy: '',
        page: 1
      }

      this.loading = true
      if (this.$route.name === 'invoices.edit' ) {
        await this.fetchItems(data)
      }

      this.loading = false
    },
    onTextChange (val) {
      this.searchItems(val)

      this.$emit('search', val)
    },
    openItemModal () {
      this.$emit('onSelectItem')
      this.openModal({
        'title': 'Add Item',
        'componentName': 'ItemModal',
        'data': {taxPerItem: this.taxPerItem, taxes: this.taxes}
      })
    },
    deselectItem () {
      this.itemSelect = null
      this.$emit('deselect')
    }
  }
}
</script>
